import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      imagen: '',
      footer: 'muestra',
      ira: '#contacto',
      cookies: 0,
      anio: '',
      mideMenos: false,
      mideMas: false,
      estira: false,
  },
  mutations: {
      cambiaImagen: function(state, img){
          state.imagen = img;
      },
      ocultaFooter: function(state){
          state.footer = 'oculta';
          state.ira = 'footer';
      },
      muestraFooter: function(state){
          state.footer = 'muestra';
          state.ira = '#contacto';
      },
      muestraCookies: function(state){
          if(localStorage.getItem('cookies') === null){
              state.cookies = 0;
          } else {
              state.cookies = localStorage.getItem('cookies');
          }
      },
      aceptaCookiesTemp: function(state){
          state.cookies = 1;
      },
      anio: function(state, anio){
          state.anio = anio;
      },
      mideMenos: function(state, mideMenos){
          state.mideMenos = mideMenos;
      },
      mideMas: function(state, mideMas){
          state.mideMas = mideMas;
      },
      estira: function(state, estira){
          state.estira = estira;
      },
  },
  actions: {
  },
  getters: {
      imagen: state => state.imagen,
      footer: state => state.footer,
      ira: state => state.ira,
      cookies: state => state.cookies,
      anio: state => state.anio,
      mideMenos: state => state.mideMenos,
      mideMas: state => state.mideMas,
      estira: state => state.estira,
  },
  modules: {
  }
})
